<template>
  <div class="custom-main custom-theme">
    <audio preload="load" id="voice">
      <source src="../../../assets/audio/new-roam.mp3" type="audio/mp3" />
    </audio>
    <a-form class="ant-advanced-search-form">
      <div class="gpws-menu-title">
        <span>&nbsp;</span>待受理处方
      </div>
      <a-row class="searchrow width-style-auto">
        <a-col span="8">
          <a-form-item label="流转时间">
            <a-date-picker v-model="search.startDate" placeholder="请选择就诊开始日期" style="width: 120px;"/>至<a-date-picker v-model="search.endDate" placeholder="请选择就诊结束日期" style="width: 120px;"/>
          </a-form-item>
        </a-col>
        <a-col span="16">
          <a-form-item style="float: right;" :colon="false" label="关键字">
            <a-input v-model="search.keyword" placeholder="请输入处方单号/患者姓名检索">
              <img class="search-btn" slot="addonAfter" src="../../../assets/img/search.png" @click="searchAction"/>
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-table size="middle" :columns="grid.columns" :loading="grid.loading" :rowSelection="{fixed:true}"
             rowKey="id" :dataSource="grid.data" :pagination="grid.pagination"
             @change="gridChangeAction" :scroll="{ x: '100%' }">
      <span slot="index" slot-scope="text, record, index">
        {{(((grid.pagination.current -1 ) * grid.pagination.pageSize) + index + 1) }}
      </span>
      <span slot="operate" slot-scope="text, record, index">
        <a @click="()=>acceptAction(record.id)">受理</a>
        <a-divider type="vertical" />
        <a @click="()=>recipeAction(record.id)">处方笺</a>
      </span>
    </a-table>
    <a-drawer title="处方受理" placement="right" width="800" :closable="true" :visible="drawer.visible" @close="onCloseDrawer">
      <a-spin :spinning="drawer.loading" tip="正在受理处方信息,请稍候...">
        <a-row>
          <a-col span="24">
            <a-card title="处方信息" size="small" :bordered="false">
              <a-row style="margin-left: 8px;">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" style="padding-left: 3px;">
                  <a-row>
                    <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">患者姓名:</span><span class="row-h-40">{{(undefined == record.name || null == record.name || '' == record.name)?'-':record.name}}</span></a-col>
                    <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">性别:</span><span class="row-h-40">{{(undefined == record.sexName || null == record.sexName || '' == record.sexName)?'-':record.sexName}}</span></a-col>
                    <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">联系电话:</span><span class="row-h-40">{{(undefined == record.phone || null == record.phone || '' == record.phone)?'-':record.phone}}</span></a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row style="margin-left: 8px;margin-bottom: 5px;">
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">处方单号:</span><span class="row-h-40">{{(undefined == record.code || null == record.code || '' == record.code)?'-':record.code}}</span></a-col>
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">就诊医院:</span><span class="row-h-40">{{(undefined == record.hospitalName || null == record.hospitalName || '' == record.hospitalName)?'-':record.hospitalName}}</span></a-col>
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">就诊科别:</span><span class="row-h-40">{{(undefined == record.department || null == record.department || '' == record.department)?'-':record.department}}</span></a-col>
              </a-row>
              <a-row style="margin-left: 8px;">
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">就诊日期:</span><span class="row-h-40">{{(undefined == record.recipeTime || null == record.recipeTime || '' == record.recipeTime)?'-':record.recipeTime}}</span></a-col>
                <a-col :sm="24" :xs="12" :md="16" :lg="16" :xl="16" :xxl="16"><span class="row-h-40">临床诊断:</span><span class="row-h-40">{{(undefined == record.diagnostic || null == record.diagnostic || '' == record.diagnostic)?'-':record.diagnostic}}</span></a-col>
              </a-row>
              <a-row style="margin-left: 8px;">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24" class="b-border l-border r-border"
                       style="padding-left: 3px;min-height: 400px;">
                  <a-row class="row-flex">
                    <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                      <a-row class="row-flex">
                        <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"
                               style="margin-left: 10px; padding-top: 3px; padding-bottom: 3px;font-weight: bold;">Rp.
                        </a-col>
                      </a-row>
                      <a-row v-if="record.type == 'SDP'">
                        <a-col style="padding-left: 20px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;" :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                          {{ record.presName }}
                        </a-col>
                      </a-row>
                      <a-row v-else-if="record.type == 'CM'">
                        <template v-if="(record.drugs||[]).length> 1">
                          <template v-for="(item, index) in record.drugs">
                            <a-col :key="'d-' + (index+1)" style="padding-left: 20px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;" :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                              {{ item.drugName }}{{ item.spec }}&nbsp;&nbsp;{{ item.dosage }}{{ item.unit }}<span v-if="(item.desc||'') != ''" style="margin-left: 5px;">,({{ item.desc }})</span>
                              <span v-if="(item.usage||'') != ''" style="margin-left: 5px;">,({{ item.usage }})</span>
                            </a-col>
                          </template>
                        </template>
                        <template v-else>
                          <template v-for="(item, index) in record.drugs">
                            <a-col :key="'d-' + (index+1)" style="padding-left: 20px;white-space:pre-wrap;word-wrap:break-word;overflow:hidden;padding-top: 3px; padding-bottom: 3px;" :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                              {{ item.drugName }}{{ item.spec }}&nbsp;&nbsp;{{ item.dosage }}{{ item.unit }}<span v-if="(item.desc||'') != ''" style="margin-left: 5px;">,({{ item.desc }})</span>
                              <span v-if="(item.usage||'') != ''" style="margin-left: 5px;">,({{ item.usage }})</span>
                            </a-col>
                          </template>
                        </template>
                      </a-row>
                      <a-row v-else>
                        <a-col v-for="(item, index) in record.drugs" :key="'d-' + (index+1)" style="padding-left: 20px;white-space:nowrap;" :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24">
                          <div>{{ (index + 1) }}.&nbsp;{{ item.drugName }}&nbsp;&nbsp;{{ item.spec}}&nbsp;&nbsp;{{ item.salesQty }}{{ item.salesUnit }}
                          </div>
                          <div style="margin-left: 5px;">
                            用法:&nbsp;&nbsp;&nbsp;{{ item.usage }}&nbsp;&nbsp;&nbsp;{{ item.dosage }}{{ item.unit }}&nbsp;&nbsp;&nbsp;{{ item.frequency }}
                          </div>
                        </a-col>
                      </a-row>
                      <a-row>
                        <a-col style="text-align: left; line-height: 24px;padding-left: 40px;margin-top: 12px;">
                          <span v-if="record.type == 'SDP'">{{ record.doses }}份{{ (record.usage || '') != '' ? ',' : '' }}&nbsp;</span>
                          <span v-else-if="record.type == 'CM'">{{ record.doses }}付{{ (record.usage || '') != '' ? ',' : '' }}&nbsp;</span>
                          {{ record.usage || '' }}
                        </a-col>
                      </a-row>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row style="margin-left: 8px;margin-bottom: 5px;">
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8">
                  <span class="row-h-40">医师:</span><span class="row-h-40">{{(undefined == record.doctorName || null == record.doctorName || '' == record.doctorName)?'-':record.doctorName}}</span>
                </a-col>
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8">
                  <span class="row-h-40">审核:</span><span class="row-h-40">&nbsp;</span>
                </a-col>
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8">
                  <span class="row-h-40">金额:</span><span class="row-h-40">{{(undefined == record.roamAmount || null == record.roamAmount)?'-':('¥ '+ record.roamAmount.toFixed(2))}}</span>
                </a-col>
              </a-row>
            </a-card>
            <a-card title="取药信息" size="small" :bordered="false">
              <a-row style="margin-left: 8px;">
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">取药方式:</span><span class="row-h-40">{{(undefined == record.takeName || null == record.takeName || '' == record.takeName)?'-':record.takeName}}</span></a-col>
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">收件人姓名:</span><span class="row-h-40">{{(undefined == record.consigneeName || null == record.consigneeName || '' == record.consigneeName)?'-':record.consigneeName}}</span></a-col>
                <a-col :sm="24" :xs="12" :md="8" :lg="8" :xl="8" :xxl="8"><span class="row-h-40">收件人电话:</span><span class="row-h-40">{{(undefined == record.consigneePhone || null == record.consigneePhone || '' == record.consigneePhone)?'-':record.consigneePhone}}</span></a-col>
              </a-row>
              <a-row style="margin-left: 8px;margin-bottom: 5px;">
                <a-col :sm="24" :xs="24" :md="24" :lg="24" :xl="24" :xxl="24"><span class="row-h-40">收件地址:</span><span class="row-h-40">{{(undefined == record.address || null == record.address || '' == record.address)?'-':record.address}}</span></a-col>
              </a-row>
            </a-card>
          </a-col>
        </a-row>
        <div class="button-container" style="margin-top: 30px;">
          <div style="float: right">
            <a-button type="primary" style="margin-right: 50px;" @click="accept">受理</a-button>
            <a-button style="margin-right: 20px;" @click="onCloseDrawer">关闭</a-button>
          </div>
        </div>
      </a-spin>
    </a-drawer>
    <recipe ref="recipe"/>
  </div>
</template>

<script>
  import {Modal} from "ant-design-vue";
  import Recipe from "@/components/roam/recipe/Recipe";
  export default {
    name: "AcceptRecipe",
    components: {Recipe},
    data() {
      return {
        interval:null,
        search:{
          keyword:'',
          startDate:'',
          endDate:''
        },
        grid: {
          loading: false,
          columns: columns,
          data: [],
          pagination: this.$pagination
        },
        drawer:{
          loading: false,
          visible:false
        },
        record:{}
      }
    },
    beforeCreate() {
      let data = [{
        text: "首页",
        path: ""
      }, {
        text: "处方流转",
        path: ""
      }, {
        text: "待受理处方",
        path: ""
      }];
      this.$store.commit('updateBreadcrumb', data);
    },
    mounted: function () {
      this.searchAction();
      this.interval = window.setInterval(() => {
        this.searchAction();
      },30000);
    },
    beforeDestroy() {
      if(undefined != this.interval && null != this.interval){
        window.clearInterval(this.interval);
      }
    },
    destroyed() {
      if(undefined != this.interval && null != this.interval){
        window.clearInterval(this.interval);
      }
    },
    methods: {
      accept:function(){
        const self = this;
        let modal = Modal.confirm({
          content: '是否确定受理当前处方配送?',
          onOk() {
            modal.destroy();
            self.drawer.loading = true;
            self.$axios.post('/api/clinic/roam/recipe/'+self.record.id+'/accept').then(function(res){
              self.drawer.loading = false;
              if(res.msg.flag == 0){
                self.$message.success({content: '流转处方受理成功.', duration: 2});
                self.record = {};
                self.onCloseDrawer();
                self.searchAction();
              }else{
                self.$message.error({content: res.msg.message, duration: 2});
              }
            },function(res){
              self.drawer.loading = false;
            });
          }
        });
      },
      recipeAction:function(id){
        this.$refs.recipe.showDrawer(id);
      },
      acceptAction:function(id){
        const self = this;
        this.$axios.get('/api/clinic/roam/recipe/'+id).then(function (res) {
          if (res.msg.flag == 0) {
            if(null != res.biz){
              self.record = res.biz;
              self.drawer.visible=true;
            }else{
              self.record = {};
            }
          }else{
            self.$message.error(res.msg.message, 2);
          }
        }, function (res) {
        });
      },
      buildParams:function(){
        let startDate = '', endDate = '';
        if(undefined != this.search.startDate && null != this.search.startDate && '' != this.search.startDate){
          startDate = this.formatDate(new Date(this.search.startDate));
        }
        if(undefined != this.search.endDate && null != this.search.endDate && '' != this.search.endDate){
          endDate = this.formatDate(new Date(this.search.endDate));
        }

        return {'entity.keyword': this.search.keyword, 'entity.status': 'B_WAIT_ACCEPT', 'startTime': startDate, 'endTime': endDate};
      },
      /**
       * 查询按钮动作
       */
      searchAction: function () {
        Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
        let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
        this.loadGrid(params);
      },
      /**
       * 分页条操作
       */
      gridChangeAction: function (pagination, filters, sorter) {
        Object.assign(this.grid, {pagination: pagination});
        let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
        this.loadGrid(params);
      },
      /**
       * 请求单页数据
       */
      loadGrid: function (params) {
        const self = this;
        this.grid.loading = true;
        this.$axios.get('/api/clinic/roam/recipes', {params: params}).then(function (res) {
          self.grid.loading = false;
          if (res.msg.flag == 0) {
            if(null == res.biz || res.biz.empty){
              self.$message.info({content: res.msg.message, duration: 2});
              Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
            }else{
              let voice = document.getElementById("voice");
              voice.currentTime = 0;
              voice.play();
              Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
            }
          } else {
            self.$message.error(res.msg.message, 2);
          }
        }, function (res) {
          self.grid.loading = false;
        });
      },
      onCloseDrawer:function (){
        this.drawer.loading = false;
        this.drawer.visible =false;
      }
    }
  }
  /**
   * 列部分
   * @type {({scopedSlots: {customRender: string}, width: number, fixed: string, title: string, align: string}|{customRender: (function(*=, *, *): *), dataIndex: string, width: number, title: string, key: string})[]}
   */
  const columns = [
    {
      title: '序号',
      align: 'center',
      fixed: 'left',
      width: 60,
      scopedSlots: {customRender: 'index'}
    },
    {
      title: '处方单号',
      dataIndex: 'code',
      key: 'code',
      width: 150,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '患者姓名',
      dataIndex: 'name',
      key: 'name',
      width: 100,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '患者电话',
      dataIndex: 'phone',
      key: 'phone',
      width: 120,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '处方类型',
      dataIndex: 'type',
      key: 'type',
      width: 100,
      align: 'center',
      customRender:(text, record, index) =>{
        if(record.type === 'SDP'){
          return '专方';
        }else{
          return '普方';
        }
      }
    },
    {
      title: '就诊医院',
      key: 'hospitalName',
      dataIndex: 'hospitalName',
      width: 150,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '开方医生',
      key: 'doctorName',
      dataIndex: 'doctorName',
      width: 100,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '取药方式',
      key: 'takeName',
      dataIndex: 'takeName',
      width: 100,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '流转时间',
      key: 'applyTime',
      dataIndex: 'applyTime',
      width: 150,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '收件人姓名',
      key: 'consigneeName',
      dataIndex: 'consigneeName',
      width: 100,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '收件人电话',
      key: 'consigneePhone',
      dataIndex: 'consigneePhone',
      width: 120,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '详细地址',
      key: 'address',
      dataIndex: 'address',
      width: 200,
      customRender:(text, record, index) =>{
        return text == undefined || text == null || text == '' ? '-' : text;
      }
    },
    {
      title: '处方金额/结算金额',
      key: 'amount',
      align: 'center',
      fixed:'right',
      width: 140,
      customRender:(text, record, index) =>{
        return record.amount == undefined || record.amount == null ? '-' : (record.amount.toFixed(2)+' / ' + record.roamAmount.toFixed(2));
      }
    },
    {
      title: '操作',
      key: 'id',
      align: 'center',
      fixed:'right',
      width: 180,
      scopedSlots: {customRender: 'operate'}
    }
  ];
</script>
<style scoped>
  .row-h-40 {
     height: 40px;
     line-height: 40px;
    margin-top: 8px;
    margin-bottom: 8px;
    padding-left: 4px;
    padding-right: 4px;
   }

  .row-h-36 {
    height: 36px;
    line-height: 36px;
  }
</style>
